<div class="container settings-tab-container">
    <div class="row" *ngIf="settings">
        <div class="col-12 text-center">
            <p class="settings-tab-sub-header">
                {{consts.LABEL_CUSTOMIZE}}
            </p>
        </div>
        <div class="col-12">
            <p class="settings-tab-label">
                {{consts.LABEL_SAMPLE}}
            </p>
            <p class="settings-tab-example-wrapper">
                {{today | date: (settings.showDayOfWeek ? consts.DAYOFWEEK_FORMAT : '') + settings.dateFormat + ' ' + settings.timeFormat}}
            </p>

            <p class="settings-tab-label">
                {{consts.LABEL_DATE_FORMAT}}
            </p>
            <mat-radio-group
                class="settings-tab-radio-group-date-format"
                [(ngModel)]="settings.dateFormat"
                (change)="onSettingsChanged()"
            >
                <div class="row mb-4">
                    <div class="col-sm-12 col-md-6">
                        <mat-radio-button value="MMM d, yyyy">
                            {{consts.DATE_FORMAT_MMM_D_YYYY}}
                        </mat-radio-button>
                        <br>
                        <mat-radio-button value="MM/dd/yyyy">
                            {{consts.DATE_FORMAT_MM_DD_YYYY}}
                        </mat-radio-button>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-radio-button value="dd/MM/yyyy">
                            {{consts.DATE_FORMAT_DD_MM_YYYY}}
                        </mat-radio-button>
                        <br>
                        <mat-radio-button value="yyyy/MM/dd">
                            {{consts.DATE_FORMAT_YYYY_MM_DD}}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <p class="settings-tab-label">
                {{consts.LABEL_TIME_FORMAT}}
            </p>
            <div class="row mb-4">
                <div class="col">
                    <mat-radio-group
                        class="settings-tab-radio-group-time-format"
                        [(ngModel)]="settings.timeFormat"
                        (change)="onSettingsChanged()"
                    >
                        <mat-radio-button
                            class="mat-radio"
                            value="h:mm a"
                        >
                            {{consts.TIME_FORMAT_AM_PM}}
                        </mat-radio-button>
                        <mat-radio-button value="HH:mm">
                            {{consts.TIME_FORMAT_24HOUR}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <p class="settings-tab-label">
                {{consts.LABEL_SHOW_DAY_OF_WEEK}}
            </p>
            <div class="row mb-4">
                <div class="col">
                    <mat-radio-group
                        class="settings-tab-radio-group-dayofweek"
                        [(ngModel)]="settings.showDayOfWeek"
                        (change)="onSettingsChanged()"
                    >
                        <mat-radio-button
                            class="mat-radio"
                            [value]=true
                        >
                            Yes
                        </mat-radio-button>
                        <mat-radio-button [value]=false>
                            No
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>
</div>
